import { type Timeframe, timeframeToSeconds } from "@opensea/graphql"
import { differenceInSeconds } from "date-fns"

// Convert time range duration to closest timeframe
export function getTimeframe(startTime: Date): Timeframe {
  const now = new Date()

  const durationSeconds = differenceInSeconds(now, startTime)

  if (durationSeconds <= timeframeToSeconds("ONE_HOUR")) {
    return "ONE_HOUR"
  }
  if (durationSeconds <= timeframeToSeconds("ONE_DAY")) {
    return "ONE_DAY"
  }
  if (durationSeconds <= timeframeToSeconds("SEVEN_DAYS")) {
    return "SEVEN_DAYS"
  }
  if (durationSeconds <= timeframeToSeconds("THIRTY_DAYS")) {
    return "THIRTY_DAYS"
  }
  if (durationSeconds <= timeframeToSeconds("ONE_YEAR")) {
    return "ONE_YEAR"
  }
  return "ALL_TIME"
}
